// Verder.jsx  →  /verder/:token
// Koper keert terug na notificatie — vult stap 4 (event/datum/budget) in
// Token bevat naam + relatie + interesses + lifeEvent van begunstigde

import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { BUDGETS, RELATIONS } from "../constants";
import { Events } from "../analytics";

export default function Verder() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [profiel, setProfiel] = useState(null);
  const [fout, setFout] = useState(null);
  const [laden, setLaden] = useState(true);

  // Stap 4 state
  const [type, setType] = useState("");
  const [datum, setDatum] = useState("");
  const [budget, setBudget] = useState(null);

  useEffect(() => {
    try {
      const d = JSON.parse(atob(token.replace(/-/g, "+").replace(/_/g, "/")));
      if (d.status !== "ingevuld") throw new Error("nog niet ingevuld");
      setProfiel(d);
      if (d.eventType) setType(d.eventType);
      if (d.eventDatum) setDatum(d.eventDatum);
      if (d.budget) setBudget(d.budget);
    } catch {
      setFout(true);
    } finally {
      setLaden(false);
    }
  }, [token]);

  const ok = budget && datum && type.trim();
  const rel = profiel ? RELATIONS.find(r => r.id === profiel.relation) : null;

  const verder = () => {
    if (!ok) return;
    Events.STAP_VOLTOOID(4);
    // Navigeer naar home met alle data voorgeladen via state
    navigate("/", {
      state: {
        preload: {
          ...profiel,
          eventType: type.trim(),
          eventDatum: datum,
          budget,
          // token bewaren zodat we suggesties kunnen genereren
          token,
        },
        startStap: 5,
      },
    });
  };

  if (laden) return (
    <main className="main">
      <div className="card fi" style={{ textAlign: "center", padding: 40 }}>
        <div className="ai-spinner" style={{ margin: "0 auto 16px" }} />
        <div style={{ color: "#8A7B73", fontSize: 15 }}>Profiel laden…</div>
      </div>
    </main>
  );

  if (fout) return (
    <main className="main">
      <div className="card fi" style={{ textAlign: "center" }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>⏳</div>
        <h2 style={{ fontFamily: "Fraunces, serif", fontSize: 22, marginBottom: 8 }}>
          Nog even wachten
        </h2>
        <p style={{ color: "#8A7B73", marginBottom: 24, lineHeight: 1.6 }}>
          De persoon heeft de link nog niet ingevuld, of de link is verlopen.
        </p>
        <a href="/" style={{
          display: "inline-block", background: "#C9856A", color: "white",
          textDecoration: "none", padding: "12px 24px", borderRadius: 50, fontWeight: 600,
        }}>← Terug naar home</a>
      </div>
    </main>
  );

  return (
    <main className="main">
      <div className="card fi">
        {/* Banner */}
        <div style={{
          background: "linear-gradient(135deg,#3D5A4C,#4a6b5a)",
          borderRadius: 20, padding: 20, marginBottom: 22,
          display: "flex", alignItems: "center", gap: 14,
        }}>
          <span style={{ fontSize: 36 }}>🎉</span>
          <div>
            <div style={{ fontSize: 16, fontWeight: 600, color: "white", marginBottom: 3 }}>
              {profiel.naam} heeft zijn/haar voorkeuren ingevuld!
            </div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.7)", lineHeight: 1.5 }}>
              {rel?.e} {rel?.l} · Vul nu het event en budget in
            </div>
          </div>
        </div>

        <div className="tag">Laatste stap</div>
        <h1 className="step">Wanneer is het <em>event</em>?</h1>
        <p className="sub">Daarna genereren we de suggesties en sturen we je een herinnering.</p>

        <div className="flabel">Type event</div>
        <input className="inp" placeholder="bijv. Verjaardag, Kerst, Jubileum…"
          value={type} onChange={e => setType(e.target.value)} autoFocus />

        <div className="flabel">Datum</div>
        <input className="inp inp-rect" type="date" value={datum}
          min={new Date().toISOString().split("T")[0]}
          onChange={e => setDatum(e.target.value)}
          style={{ marginBottom: 18 }} />

        <div className="flabel">Budget</div>
        <div className="bgrid">
          {BUDGETS.map(b => (
            <div key={b.id} className={"bcard " + (budget === b.id ? "sel" : "")}
              onClick={() => setBudget(b.id)}>
              <div className="bl">{b.l}</div>
              <div className="bs">{b.s}</div>
            </div>
          ))}
        </div>

        <button className={"bfull bn " + (ok ? "gr" : "off")}
          style={{ marginTop: 8 }} onClick={verder}>
          Bekijk suggesties ✓
        </button>
      </div>
    </main>
  );
}
